const DEVICE_ID_KEY = 'petnotify_device_id'
const DEVICE_ID_COOKIE = 'petnotify_device_id'

function createDeviceId() {
  if (window.crypto && 'randomUUID' in window.crypto) {
    return window.crypto.randomUUID()
  }

  return `${Date.now()}-${Math.random().toString(36).slice(2)}`
}

function getCookie(name: string) {
  const value = document.cookie
    .split('; ')
    .find((cookie) => cookie.startsWith(`${name}=`))

  return value ? decodeURIComponent(value.split('=').slice(1).join('=')) : null
}

function setCookie(name: string, value: string) {
  const oneYear = 60 * 60 * 24 * 365
  document.cookie = `${name}=${encodeURIComponent(
    value,
  )}; path=/; max-age=${oneYear}; SameSite=Lax`
}

function getDeviceId() {
  try {
    const storedDeviceId = window.localStorage.getItem(DEVICE_ID_KEY)

    if (storedDeviceId) {
      return storedDeviceId
    }

    const cookieDeviceId = getCookie(DEVICE_ID_COOKIE)
    const deviceId = cookieDeviceId || createDeviceId()

    window.localStorage.setItem(DEVICE_ID_KEY, deviceId)
    setCookie(DEVICE_ID_COOKIE, deviceId)

    return deviceId
  } catch (error) {
    const cookieDeviceId = getCookie(DEVICE_ID_COOKIE)
    const deviceId = cookieDeviceId || createDeviceId()

    setCookie(DEVICE_ID_COOKIE, deviceId)

    return deviceId
  }
}

function parseBrowser(userAgent: string) {
  if (/Edg\//.test(userAgent)) {
    return { name: 'Edge', version: userAgent.match(/Edg\/([\d.]+)/)?.[1] }
  }

  if (/Chrome\//.test(userAgent) && !/Chromium\//.test(userAgent)) {
    return { name: 'Chrome', version: userAgent.match(/Chrome\/([\d.]+)/)?.[1] }
  }

  if (/Firefox\//.test(userAgent)) {
    return {
      name: 'Firefox',
      version: userAgent.match(/Firefox\/([\d.]+)/)?.[1],
    }
  }

  if (/Safari\//.test(userAgent) && /Version\//.test(userAgent)) {
    return { name: 'Safari', version: userAgent.match(/Version\/([\d.]+)/)?.[1] }
  }

  return { name: 'Unknown', version: undefined }
}

function parseOs(userAgent: string) {
  const iosMatch = userAgent.match(/(?:iPhone|iPad|iPod).*OS ([\d_]+)/)
  if (iosMatch) {
    return `iOS ${iosMatch[1].replace(/_/g, '.')}`
  }

  const macMatch = userAgent.match(/Mac OS X ([\d_]+)/)
  if (macMatch) {
    return `macOS ${macMatch[1].replace(/_/g, '.')}`
  }

  const androidMatch = userAgent.match(/Android ([\d.]+)/)
  if (androidMatch) {
    return `Android ${androidMatch[1]}`
  }

  const windowsMatch = userAgent.match(/Windows NT ([\d.]+)/)
  if (windowsMatch) {
    return `Windows ${windowsMatch[1]}`
  }

  return 'Unknown'
}

export function getWebDeviceInfo() {
  try {
    const userAgent = navigator.userAgent || ''
    const browser = parseBrowser(userAgent)

    return {
      device_id: getDeviceId(),
      device_type: 'web',
      device_model: 'Web Browser',
      os_version: parseOs(userAgent),
      app_version: import.meta.env.VITE_APP_VERSION || 'web',
      login_time: new Date().toISOString(),
      browser_name: browser.name,
      browser_version: browser.version,
      user_agent: userAgent,
      screen_resolution: `${window.screen.width}x${window.screen.height}`,
      timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
      locale: navigator.language,
      cookies_enabled: navigator.cookieEnabled,
    }
  } catch (error) {
    return null
  }
}
